<template>
  <div>
    <el-image
      :preview-src-list="value"
      :ref="id"
      src=""
    ></el-image>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: "previewImage"
    }
  },
  data() {
    return {
    }
  },
  methods: {
    preview() {
      this.$nextTick(() => {
        this.$refs[this.id].$data.showViewer = true;
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-image__error {
  display: none;
}
/deep/ .el-image {
  display: inline;
}
</style>

